import type { FC, ReactNode } from 'react'

import dynamic from 'next/dynamic'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'

/* the gallery is a WebGL scene — it only exists in the browser */
const FluidGallery = dynamic(
    () => import('@/components/fluid-gallery/fluid-gallery').then(m => m.FluidGallery),
    {
        ssr: false,
        loading: () => <div className='h-screen w-full bg-surface' />
    }
)

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Gallery'
                description='Twelve photographs on one liquid canvas. Scroll to switch them, click to open one full-bleed.'
            />

            <FluidGallery />
        </Layout>
    )
}

export default Home
